<template>
  <div class="toast-container">
    <transition-group name="toast-fade" tag="div">
      <div v-for="notification in notifications" :key="notification.id" 
           :class="['toast-message', `toast-${notification.type}`]">
        {{ notification.message }}
      </div>
    </transition-group>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { notificationBus } from '../utils/notificationBus';

const notifications = computed(() => notificationBus.notifications);
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}
.toast-message {
  padding: 12px 20px;
  border-radius: 6px;
  color: #fff;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  transition: all 0.5s ease;
}
.toast-success {
  background-color: #28a745;
}
.toast-error {
  background-color: #dc3545;
}
.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
.toast-fade-leave-active {
  position: absolute;
}
</style>